import { connect } from 'react-redux';
import { ToolsPanelComponent } from './tools-panel';
import { toolsPanelDispatcher } from './connect/tools-panel.dispatcher';
import { toolsPanelSelector } from './connect/tools-panel.selector';
export const ToolsPanel = connect(toolsPanelSelector, toolsPanelDispatcher)(ToolsPanelComponent);